// Quantity limit rules:
// - stock filled and > 0  -> the customer can buy at most that amount
// - stock explicitly 0    -> only 1 unit (pre-order / reposition)
// - stock not configured  -> no limit (falls back to 99)
export const maxQtyFor = (product) => {
  const raw = product?.stock;
  if (raw === null || raw === undefined || raw === "") return 99;
  const stock = Number(raw);
  if (!Number.isFinite(stock)) return 99;
  return stock > 0 ? stock : 1;
};

export const clampQty = (product, qty) => {
  const n = Math.floor(Number(qty) || 1);
  return Math.max(1, Math.min(n, maxQtyFor(product)));
};
